// extracted by mini-css-extract-plugin
export var compactFilters = "_dq-4";
export var detailImage = "_dq-1";
export var dropdownContainer = "_dq-2";
export var imageContainer = "_dq-0";
export var selectedCard = "_dq-3";